// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 字体 */\n/* Colors\n-------------------------- */\n/* 尺寸\n-------------------------- */\n.tip-style p[data-v-483ebf3c] {\n  line-height: 23px;\n}\n", ""]);
// Exports
module.exports = exports;
